import Axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import { ButtonStyle } from "../../assets/css/components/ButtonStyle";
import { API_URL } from "../../lib/const";
import CourseInputAsync from "../components/CourseInputAsync";
import DataForm from "../components/DataForm";
import SpecialtyInputAsync from "../components/SpecialtyInputAsync";
import TagStatus from "../components/TagStatus";
import { Card, FieldSet } from "../elements";
import {
  fetchUserEnrollments,
  fetchEligibleProcesses,
} from "../services/enrollment_services";

const OnboardingProcesses = ({ className, history }) => {
  const user = localStorage.getItem("userId");

  const [userEnrollments, setUserEnrollments] = useState([]);
  const [eligibleProcesses, setEligibleProcesses] = useState([]);
  const [cursoFilter, setCursoFilter] = useState("");
  const [especialidadeFilter, setEspecialidadeFilter] = useState("");

  const handleSubscription = (onboarding) => {
    const paylaod = {
      onboarding,
      user,
    };
    Axios.post(`${API_URL}/onboarding/enrollments`, paylaod)
      .then((res) => {
        toast.success("Inscrição realizada com sucesso!");
        history.push(`/inscrever/${res.data.token}`);
      })
      .catch(() => {
        toast.error("Não foi possível realizar sua inscrição, tente novamente");
      });
  };

  const handleFollowSubscription = (token) => {
    history.push(`/inscrever/${token}`);
  };

  useEffect(
    () => {
      if (user) {
        fetchUserEnrollments(user).then((data) => setUserEnrollments(data));
      }
      fetchEligibleProcesses({}).then((data) => setEligibleProcesses(data));
    },
    [user]
  );

  useEffect(
    () => {
      fetchEligibleProcesses({
        course: cursoFilter,
        specialty: especialidadeFilter,
      }).then((data) => setEligibleProcesses(data));
    },
    [cursoFilter, especialidadeFilter]
  );

  return (
    <div className={className}>
      <FieldSet title="Minhas Incrições">
        {userEnrollments.length > 0 ? (
          userEnrollments.map((en) => (
            <div className="onboarding-card">
              <Card title={en.onboarding.name}>
                <TagStatus
                  text={en.status.name}
                  backgroundColor={en.status.color}
                />
                <div className="onboarding-card-details">
                  <div className="onboarding-course">
                    <span>Curso: </span>
                    <strong>{en.onboarding.course.name}</strong>
                  </div>
                  <div className="onboarding-specialty">
                    <span>Especialidade: </span>
                    <strong>{en.onboarding.specialty}</strong>
                  </div>
                </div>
                <div className="onboarding-subscribe-button">
                  <ButtonStyle
                    onClick={() => handleFollowSubscription(en.token)}
                  >
                    Acompanhar
                  </ButtonStyle>
                </div>
              </Card>
            </div>
          ))
        ) : (
          <span className="no-subscription-text">
            Nenhuma inscrição encontrada
          </span>
        )}
      </FieldSet>

      <FieldSet title="Processos disponíveis">
        <DataForm>
          <div className="onboarding-filter">
            <div style={{ width: "48%" }}>
              <CourseInputAsync
                name="course"
                onChange={(value) => setCursoFilter(!value ? "" : value.name)}
              />
            </div>
            <div style={{ width: "48%" }}>
              <SpecialtyInputAsync
                name="specialty"
                onChange={(value) =>
                  setEspecialidadeFilter(!value ? "" : value.name)
                }
              />
            </div>
          </div>
        </DataForm>
        {eligibleProcesses.length > 0 ? (
          eligibleProcesses.map((onb) => (
            <div className="onboarding-card">
              <Card title={onb.name}>
                <div className="onboarding-card-details">
                  <div className="onboarding-course">
                    <span>Curso: </span>
                    <strong>{onb.course.name}</strong>
                  </div>
                  <div className="onboarding-specialty">
                    <span>Especialidade: </span>
                    <strong>{onb.specialty}</strong>
                  </div>
                </div>
                <div className="onboarding-subscribe-button">
                  <ButtonStyle onClick={() => handleSubscription(onb.id)}>
                    Inscrever
                  </ButtonStyle>
                </div>
              </Card>
            </div>
          ))
        ) : (
          <span className="no-subscription-text">
            Nenhum processo disponível no momento
          </span>
        )}
      </FieldSet>
    </div>
  );
};

export default styled(OnboardingProcesses)`
  width: 70%;
  margin-left: 15%;

  .no-subscription-text {
    margin-left: 35%;
  }

  .onboarding-card-details {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
  }

  .onboarding-filter {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: -2%;
  }

  .onboarding-course {
    margin-left: 5%;
  }

  .onboarding-specialty {
    margin-top: 10px;
    margin-left: 5%;
  }

  .onboarding-subscribe-button {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }

  .onboarding-card {
    width: 100%;
    margin-bottom: 20px;
  }

  ${ButtonStyle} {
    margin-right: 5%;
    margin-top: 10px;
    margin-bottom: 5px;
    background-color: #489d96;
    color: white;
    strong {
      font-size: 20px;
      font-weight: 400;
    }
  }
`;
